// セッション継続用: ビューワーがリロードされても同じ pincode で再接続できるよう
// sessionStorage に保持する。タブを閉じれば消えるが、リロードでは生存する特性が
// この用途に適合。host が共有を継続している限り signaling は同 pincode で
// 再接続を受け付ける (room.ts の設計)。キーは @wincast/shared で一元管理。

import { PINCODE_LENGTH, VIEWER_PINCODE_STORAGE_KEY } from "@wincast/shared";

// 入力文字列から数字以外を除去する。ハイフン等の整形文字を落として
// 生の暗証番号を得る。純粋関数。
export function normalizePincode(raw: string): string {
  return raw.replace(/\D/g, "");
}

export function savePincodeToSession(pincode: string): void {
  try {
    sessionStorage.setItem(VIEWER_PINCODE_STORAGE_KEY, pincode);
  } catch {
    // Private モード等で sessionStorage が使えない場合は無視
  }
}

export function clearPincodeFromSession(): void {
  try {
    sessionStorage.removeItem(VIEWER_PINCODE_STORAGE_KEY);
  } catch {
    // noop
  }
}

export function getPincodeFromSession(): string | null {
  try {
    const raw = sessionStorage.getItem(VIEWER_PINCODE_STORAGE_KEY);
    if (!raw) return null;
    const normalized = normalizePincode(raw);
    if (normalized.length !== PINCODE_LENGTH) {
      clearPincodeFromSession();
      return null;
    }
    return normalized;
  } catch {
    return null;
  }
}
